import moment from 'moment';

/**
 * Formats a single date string into a user-friendly dashboard format.
 * @param {String|Date} dateSource - The date to format.
 * @returns {String} Formatted string (e.g., "Today at 12:00 PM", "Aug 1, 2026 at 11:59 PM").
 */
export function formatDate(dateSource) {
    if (!dateSource) return '—';

    const targetDate = moment(dateSource);
    const today = moment();
    const tomorrow = moment().add(1, 'day');
    const timeStr = targetDate.format('h:mm A');

    if (targetDate.isSame(today, 'day')) return `Today at ${timeStr}`;
    if (targetDate.isSame(tomorrow, 'day')) return `Tomorrow at ${timeStr}`;
    
    // Explicit year check: handles both past and future years cleanly
    if (targetDate.year() === today.year()) {
        return `${targetDate.format('MMM D')} at ${timeStr}`;
    }
    return `${targetDate.format('MMM D, YYYY')} at ${timeStr}`;
}

export function formatCreatedDate(dateSource) {
    if (!dateSource) return '—';

    const created = moment(dateSource);
    const now = moment();

    // 1. Calendar year cross-check
    if (created.year() < now.year()) {
        return `${created.format('MMM D, YYYY')}`; // Guarantees year displays for ALL past years
    }

    // 2. Direct time interval differences for the current year
    const diffMonths = now.diff(created, 'months');
    const diffDays = now.diff(created, 'days');
    const diffHours = now.diff(created, 'hours');
    const diffMinutes = now.diff(created, 'minutes');

    // 3. Fallback priority chain
    if (diffMonths > 0) {
        return `${created.format('MMM D')}`; // Year omitted safely because it is the current year
    }
    if (diffDays > 0) {
        return `${diffDays} ${diffDays === 1 ? 'day' : 'days'} ago`;
    }
    if (diffHours > 0) {
        return `${diffHours} ${diffHours === 1 ? 'hour' : 'hours'} ago`;
    }
    if (diffMinutes > 0) {
        return `${diffMinutes} ${diffMinutes === 1 ? 'minute' : 'minutes'} ago`;
    }

    return 'Just now';
}